<template>
  <router-link :to="`/profiles/${professional.userId}`">
    <div class="professional-card shadow-and-scale">
      <span
        v-if="professional.isPremium"
        class="professional-card-badge premium-badge"
      ><img
          src="@/assets/img/badge.svg"
          alt=""
          srcset=""
        ></span>
      <span
        class="professional-card-avatar professional-avatar"
        :style="{backgroundImage: `url('${professional.profilePictureUrl || `https://ui-avatars.com/api/?size=512&background=386B61&color=fff&name=${professional.name}+${professional.lastName}`} ')` }"
      />
      <h2 class="professional-card-name">
        {{ professional.name }} {{ professional.lastName }}
      </h2>
      <h3 class="professional-card-title">
        {{ professional.title }}
      </h3>
      <h3 v-if="professional.address" class="professional-card-address">
        {{ professional.address.city }} {{ professional.address.state && ` - ${professional.address.state}`}}
      </h3>
      <div class="professional-card-specialties tags-wrapper">
        <span
          class="tag-light"
          v-for="(specialty, index) in professional.specialties"
          :key="index"
        ><span class="tag-text">{{specialty}}</span></span>
      </div>
      <span class="button is-primary">
        Ver Perfil
      </span>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    professional: Object
  }
}
</script>
